import React, { FC } from 'react'
import { Fade } from '@mui/material'
import { ErrorBoundary } from '../'

interface IProps {
  children?: JSX.Element
}

const CustomFade: FC<IProps> = ({ children }) =>
  children ? (
    <ErrorBoundary>
      <Fade in timeout={{ enter: 200, exit: 200 }}>
        <span>{children}</span>
      </Fade>
    </ErrorBoundary>
  ) : null

export default CustomFade
